/** 手动过载模式（VITE_OVERLOAD_MODE=true）或应用内展示 */
export function OverloadScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-100 via-brand-50 to-ink-50 flex flex-col items-center justify-center px-5 py-12 text-center">
      <img src="/logo_1.png" alt="方法星球" className="h-12 w-12 rounded-xl shadow-soft mb-6" />
      <div className="text-4xl mb-4" aria-hidden="true">🚦</div>
      <h1 className="text-h2 text-ink-900 mb-3 max-w-xs">
        访问人数太多，挤爆了，请稍后访问
      </h1>
      <p className="text-body text-ink-600 max-w-sm leading-relaxed">
        当前访问高峰，服务器正在全力应对。请稍等几分钟后再打开链接，感谢您的耐心。
      </p>
      <p className="mt-8 px-4 py-3 rounded-xl bg-white/70 text-sm text-ink-500 max-w-sm">
        请勿频繁刷新页面，以免加重拥堵
      </p>
      <p className="mt-10 text-sm text-ink-400">方法星球 · 邹城中考志愿测算</p>
    </div>
  )
}
